import React, { FC } from 'react'
import { IconProps } from '@chakra-ui/react'
import { motion } from 'framer-motion'
import { Download } from './Download'


export const AnimatedDownload: FC<IconProps & { small?: boolean }> = (props) => {
    return (
        <motion.div
            animate={props.small ?
                { clipPath: 'polygon(0% 50%, 15% 50%, 15% 60%,85% 60%, 85% 50%, 100% 50%, 100% 100%, 0 100%)' } :
                { clipPath: 'polygon(0% 50%, 15% 50%, 15% 78%,85% 78%, 85% 50%, 100% 50%, 100% 100%, 0 100%)' }}
            initial={{ clipPath: 'polygon(0% 0%, 15% 0%, 15% 0%,85% 0%, 85% 0%, 100% 0%, 100% 100%, 0 100%)' }}
            style={{ lineHeight: '0px' }}
            transition={{
                duration: 1.5,
                repeat: Infinity, repeatDelay: 0.7, ease: 'linear',
            }}
        >
            <Download  {...props} />
        </motion.div>
    )
}